export default __webpack_public_path__ + "static/media/Picture3-1024x683.ee28842a.jpg";